import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useAppSelector } from 'hooks/store';
import { useState } from 'react';
import { FormattedNumber } from 'react-intl';

import { OptionDeleteModal, OptionSelectionModal } from '../Modals';

export const OptionSelectionItem = () => {
  const account = useAppSelector((state) => state.account.account);
  const intCurrency = useAppSelector((state) => state.account.account?.intCurrency);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  return (
    <div className="flex items-center justify-between max-w-sm w-full mb-2 border-b pb-2 last:pb-0 last:border-b-0">
      <div className="relative flex items-start">
        <div className="flex h-5 items-center">
          <input
            id="comments"
            aria-describedby="comments-description"
            name="comments"
            type="checkbox"
            className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="comments" className="font-medium text-gray-700 truncate">
            Option Selection
          </label>
        </div>
      </div>

      <div className="flex items-center text-sm text-gray-500 font-medium">
        <div className="border-r pr-3">
          +{/*eslint-disable-next-line react/style-prop-object*/}
          <FormattedNumber
            currency={account?.currency}
            style="currency"
            value={10}
            maximumFractionDigits={intCurrency ? 0 : 2}
          />
        </div>

        <PencilSquareIcon
          className="w-5 h-5 text-primary cursor-pointer mr-2 md:hover:opacity-60 ml-2"
          onClick={() => {
            setOpenEditModal(true);
          }}
        />
        <TrashIcon
          className="w-5 h-5 text-red-500 cursor-pointer md:hover:opacity-60"
          onClick={() => {
            setOpenDeleteModal(true);
          }}
        />
      </div>

      <OptionDeleteModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        mode="selection"
      />
      <OptionSelectionModal open={openEditModal} setOpen={setOpenEditModal} />
    </div>
  );
};
